import { useCallback, useEffect, useState } from "react";
import { useAuthContext } from "@/contexts/auth";
import { fetchPrefillData } from "@/utils/contacting";
import { useBrand } from "@/contexts/cdpConfig";
import { useVisibilityEvent } from "./useVisibilityEvent";
export const usePrefill = ({ crsBaseUrl, onLoad }) => {
    const [isPrefilled, setIsPrefilled] = useState(false);
    const brand = useBrand();
    const prefillUrl = `${crsBaseUrl}/prefill-form?brand=${brand}`;
    const { validToken } = useAuthContext();
    const prefill = useCallback(async () => {
        try {
            setIsPrefilled(true);
            if (validToken) {
                const userData = (await fetchPrefillData(prefillUrl, validToken));
                onLoad(userData);
            }
        }
        catch (error) {
            console.log(error);
            onLoad();
        }
    }, [onLoad, validToken, prefillUrl]);
    useVisibilityEvent({ cb: prefill, type: "visible" });
    useEffect(() => {
        if (validToken && !isPrefilled) {
            prefill();
        }
    }, [validToken, onLoad, prefill, isPrefilled]);
};
